import { connect } from 'react-redux';
import {
  STEP_TWO_LOCATIONS_SUPP_AUTH,
  STEP_TWO_PRODUCTS_SUPP_AUTH,
} from 'feature/loading-management/utils/const';
import * as R from 'ramda';
import SelectProducts from '../../../create-new-common/SelectProducts';
import {
  getAllEnabled,
  getInactiveListOptions,
  getLocation,
  getProduct,
  getSupplier,
  setBatchEnabledOptions,
  setEnabledOptions,
  setHasUnsavedChanges,
} from '../../store/createNewSupplierAuthSlice';

export const mapState = state => {
  const { authorizationBy } = state.loadingManagement.createNewSupplierAuth;
  const identifier = R.o(R.prop('nameShort'), getSupplier)(state);
  const location = R.o(R.prop('nameShort'), getLocation)(state);
  const product = R.o(R.prop('nameShort'), getProduct)(state);

  const toggleAllMessage = `Turn On All ${
    authorizationBy === 'location' ? 'Products' : 'Locations'
  }`;

  return {
    allEnabled: getAllEnabled(state),
    authorizationBy,
    // Todo: Future: "What (products, locations) do you want to turn on for SupplierName at LocationName?"
    header: `${
      (authorizationBy === 'location'
        ? STEP_TWO_PRODUCTS_SUPP_AUTH
        : STEP_TWO_LOCATIONS_SUPP_AUTH) + identifier
    } ${authorizationBy === 'location' ? 'at' : 'for'} ${
      authorizationBy === 'location' ? location : product
    }?`,
    identifier,
    inactiveListOptions: getInactiveListOptions(state),
    location,
    product,
    toggleAllMessage,
  };
};

export const mapDispatchToProps = dispatch => ({
  setBatchEnabledOptions: payload => dispatch(setBatchEnabledOptions(payload)),
  setEnabledOptions: payload => dispatch(setEnabledOptions(payload)),
  setHasChangesToStepTwo: hasChanges => {
    if (hasChanges) {
      dispatch(setHasUnsavedChanges(true));
    }
  },
});

export default connect(mapState, mapDispatchToProps)(SelectProducts);
